"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const matchers_1 = require("../parsers/matchers");
const tokeniser_1 = require("../parsers/tokeniser");
const simpleMatchers = [
    matchers_1.SpeechSingleMatcher,
    matchers_1.SpeechDoubleMatcher,
    matchers_1.ComparisonMatcher,
    matchers_1.InvalidOpComboMatcher,
    matchers_1.InvalidOpTripletMatcher,
    matchers_1.InvalidDecimalMatcher,
    matchers_1.WhitespaceMatcher,
    matchers_1.IntegerMatcher,
    matchers_1.OperatorMatcher,
    matchers_1.FunctionMatcher,
    matchers_1.PlaceholderMatcher,
    matchers_1.VariableMatcher,
    matchers_1.CommaMatcher,
    matchers_1.SpreadMatcher,
    matchers_1.ParensMatcher,
    matchers_1.SquareParensMatcher,
];
const getTokensForExpression = (expression) => (0, tokeniser_1.getTokens)(expression, simpleMatchers);
exports.default = getTokensForExpression;
